export default (theme) => ({
  root: {
    padding: theme.spacing(3),
    position: 'relative',
    height: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  filterIcon: {
    marginRight: theme.spacing(1),
  },
  filterWropper: {
    display: 'flex',
  },
  // mesma altura do gráfico (padrão do Highcharts) para alinhar os cards
  empty: {
    height: 400,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
  },
})
